import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getStaticUrl } from "js/config";
import { BeautifulDialog } from "js/react/components/Dialogs/BaseDialog";
import { Gap10 } from "js/react/components/Gap";
import Analytics from "js/analytics";

import { DialogBody, DialogTitle, WorkspaceSelect } from "./components/DialogComponents";

function TrialPausedDialogForMember(props: { onClose: () => void }) {
    const { onClose } = props;
    const { t } = useTranslation();

    useEffect(() => {
        Analytics.Dunning.TrialPausedDialogForMemberOpened();
    }, []);

    const handleSwitchWorkspace = () => {
        Analytics.Dunning.TrialPausedDialogForMemberSwitchWorkspaceClicked();
        onClose();
    };

    const handleCreateWorkspace = () => {
        Analytics.Dunning.TrialPausedDialogForMemberCreateWorkspaceClicked();
        onClose();
    };

    return (
        <BeautifulDialog preventClose>
            <DialogBody>
                <DialogTitle>
                    <img src={getStaticUrl("/images/beautifulai-logos/beautifulai-checkout-logo.svg")} />
                    <Gap10 />
                    <div>{t("Your trial is on hold")}</div>
                    <p>{t("We couldn't process your payment. Ask your workspace owner to update the payment method to restore access.")}</p>
                </DialogTitle>
                <WorkspaceSelect
                    onSwitchWorkspace={handleSwitchWorkspace}
                    onCreateWorkspace={handleCreateWorkspace}
                />
            </DialogBody>
        </BeautifulDialog>
    );
}

export default TrialPausedDialogForMember;
